import React, { useEffect, useState } from 'react';
import NavbarAdminMex from '../components/navbar';
import { Form, Select, Button, Card, message } from 'antd';
import axios from 'axios';
import './sucursalVendedor.css';

const VendedorForm = () => {
  const [form] = Form.useForm();
  const [vendors, setVendors] = useState([]);
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchVendors();
    fetchBranches();
  }, []);

  const fetchVendors = async () => {
    try {
      const response = await axios.get('https://99envios.app/api/online/vendedor-listar-vendedores');
      if (response.data.vendedores && Array.isArray(response.data.vendedores)) {
        setVendors(response.data.vendedores);
      } else {
        console.error('Formato de respuesta inválido:', response.data);
        setVendors([]);
        message.error('Error en el formato de datos de vendedores');
      }
    } catch (error) {
      console.error('Error fetching vendors:', error);
      setVendors([]);
      message.error('Error al cargar vendedores');
    }
  };

  const fetchBranches = async () => {
    try {
      const response = await axios.get('https://99envios.app/api/online/listar-sucursales');
      setBranches(response.data.sucursales);
    } catch (error) {
      message.error('Error al cargar sucursales');
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const selectedVendor = vendors.find(v => v.email === values.vendedor);
      if (!selectedVendor) {
        throw new Error('Vendedor no encontrado');
      }
      
      await axios.post(
        `https://99envios.app/api/online/vendedor-asignar-sucursales/${selectedVendor.id}`,
        {
          email: values.vendedor,
          codigo_sucursal: values.sucursales
        }
      );
      message.success('Sucursales asignadas con éxito');
      form.resetFields();
    } catch (error) {
      console.error('Error assigning branches:', error);
      message.error('Error al asignar sucursales');
    }
    setLoading(false);
  };

  return (
    <>
      <NavbarAdminMex title={"Asignar Sucursales a Vendedor"}/>
      <div className="vendor-container">
        <Card className="vendor-card">
          <Form
            form={form}
            name="vendedor_form"
            onFinish={onFinish}
            layout="vertical"
            className="vendor-form"
          >
            <Form.Item
              name="vendedor"
              label={<span className="form-label">Vendedor</span>}
              rules={[{ required: true, message: 'Por favor seleccione el vendedor' }]}
            >
              <Select
                className="vendor-select"
                placeholder="Seleccione un vendedor"
                options={vendors.map(v => ({ 
                  label: `${v.email} (ID: ${v.id})`, 
                  value: v.email 
                }))}
              />
            </Form.Item>

            <Form.Item
              name="sucursales"
              label={<span className="form-label">Sucursales</span>}
              rules={[{ required: true, message: 'Por favor seleccione al menos una sucursal' }]}
            >
              <Select
                mode="multiple"
                className="vendor-select"
                placeholder="Seleccione las sucursales"
                options={branches.map(b => ({ 
                  label: b.nombre_sucursal, 
                  value: b.codigo_sucursal 
                }))}
              />
            </Form.Item>

            <Form.Item>
              <Button 
                type="primary" 
                htmlType="submit" 
                loading={loading}
                className="vendor-button"
              >
                Asignar Sucursales
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </>
  );
};

export default VendedorForm;
